import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import Sheet from 'marketplace/modules/ui-sheet';
import {FocusTrap} from 'components/FocusTrap';
import {FilterSort} from '../FilterSort';
import * as locales from '../../locales';

interface Props {
  active?: boolean;
  showResetAll?: boolean;
  onResetAll?: any;
  onApply?: any;
  sortOptions?: any;
  sortBy?: string;
  renderFilters?: any;
  onSortChange?: any;
  onCloseClick?: any;
  open: boolean;
}

function NO_OP() {}

const style = {
  h4: 'heading--4',
  sheet: 'ui-sheet',
  button:
    'js-ui-sheet-activator marketing-button marketing-button--skin-light marketing-button--small shop-filters__button hide--desktop hide--tablet',
  sheetOpen: 'ui-sheet__visible',
  sheetHeader: 'ui-sheet__header',
  sheetFooter: 'ui-sheet__footer',
  sheetSection: 'ui-sheet__section',
  sheetBody: 'ui-sheet__body',

  shopFiltersName: 'shop-filters__name',
  sheetCloseButton: 'float--right ui-sheet__close',
  sheetApplyButton:
    'js-ui-sheet-deactivator marketing-button marketing-button--block marketing-button--small',

  resetAllButton: 'shop-filters__reset-filters body-link ui-popover__container',
};

type ComposedProps = WithI18nProps & Props;

function setScroll(enabled) {
  const bodyScroll =
    document.scrollingElement || document.documentElement || document.querySelector('html');
  (bodyScroll as HTMLElement).style.overflow = enabled ? '' : 'hidden';
}

class FilterSheetComponent extends React.PureComponent<ComposedProps> {
  filterRef: any;
  filterSheet: Sheet;

  constructor(props: ComposedProps) {
    super(props);
  }

  handleSheetResetAllClick = () => {
    const {onResetAll = NO_OP} = this.props;
    onResetAll();
  };

  componentDidUpdate() {
    setScroll(!this.props.open);
  }

  componentDidMount() {
    setScroll(!this.props.open);
  }

  componentWillUnmount() {
    setScroll(true);
  }

  render() {
    const {
      i18n,
      active,
      onApply = NO_OP,
      onCloseClick = NO_OP,
      onSortChange = NO_OP,
      sortOptions = [],
      sortBy,
      open,
      children,
    } = this.props;

    return (
      <FocusTrap active={open}>
        {(focusRef) => (
          <div
            ref={focusRef}
            className={classNames(style.sheet, {
              [style.sheetOpen]: open,
            })}
          >
            <div className={style.sheetHeader}>
              <button type="button" onClick={onCloseClick} className={style.sheetCloseButton}>
                &times;
              </button>
              <button
                type="button"
                onClick={this.handleSheetResetAllClick}
                disabled={!active}
                className={style.resetAllButton}
              >
                {i18n.translate('resetAllFiltersCTA')}
              </button>
            </div>
            <div className={style.sheetFooter}>
              <button type="button" onClick={onApply} className={style.sheetApplyButton}>
                {i18n.translate('mobileFilterCompleteText')}
              </button>
            </div>
            <section className={style.sheetSection}>
              <div className={style.sheetBody}>
                <span className={classNames(style.h4, style.shopFiltersName)}>
                  {i18n.translate('sortFiltersLabel')}
                </span>
                <FilterSort
                  forSheet
                  active={active}
                  sortOptions={sortOptions}
                  onSelectChange={onSortChange}
                  selected={sortBy}
                />
                {children}
              </div>
            </section>
          </div>
        )}
      </FocusTrap>
    );
  }
}

export const FilterSheet = withI18n({
  id: 'ShopFilters',
  fallback: locales.en,
})(FilterSheetComponent);
